import { motion } from 'framer-motion';
import styled from 'styled-components';

export const ResourcesNLPSearchBarHistoryWrapper = styled(motion.div).attrs({
  initial: { height: 0 },
  animate: { height: 'auto' },
  exit: { height: 0, overflow: 'hidden' },
})`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;

  transform: translateY(-4px);

  width: 100%;
  max-height: 324px;

  padding: 0px 12px 21px 12px;

  background: #ffffff;

  border-radius: 0px 0px 8px 8px;

  overflow-y: auto;
`;

export const ResourcesNLPSearchBarHistoryClearButtonContainer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const ResourcesNLPSearchBarHistoryClearCTA = styled.button`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  text-align: right;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourcesNLPSearchBarHistoryList = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  overflow-y: auto;
  gap: 9px;
`;

export const ResourcesNLPSearchBarHistoryItem = styled.div`
  width: 100%;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  cursor: pointer;
`;

export const ResourcesNLPSearchBarHistoryItemDate = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const ResourcesNLPSearchBarHistoryItemLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;

  color: rgba(23, 28, 51, 0.5);
`;
